<template>
  <div>
    <TopMenu
      :backOverwrite="displayStatus !== 'main' ? () => { displayStatus = 'main' } : null"
      :title="isEdit ? $t('Edit Jingle Block') : $t('Add Jingle Block')"
    />
    <div class="view">
      <DesktopBackLink :to="ROUTE_JINGLE_SCHEDULE" :label="$t('Jingle Schedule')" />
      <transition name="fade" appear>
        <div>
          <template v-if="displayStatus === 'daysOfWeek'">
            <MultiDaysOfWeekPicker
              :initValue="selectedDaysOfWeek"
              :onChange="daySelectChange"
              :onPickingDone="() => { displayStatus = 'main' }"
            />
          </template>
          <template v-if="displayStatus === 'main'">
            <div class="d-flex justify-content-between align-items-center p-1 mt-2">
              <div class="pl-4"><strong>{{$t('Days')}}</strong></div>
              <div class="col-8 pr-0">
                <a v-if="!isEdit" href="#" @click.prevent="displayStatus = 'daysOfWeek'">
                  <div class="bg-dark text-white px-3 py-2 d-block d-flex justify-content-start align-items-center rounded clickable">
                    <span>{{ selectedDaysOfWeek.size > 0 ? Array.from(selectedDaysOfWeek).sort().map(_i => daysOfWeek[_i].name).join(', ') : ' ' }}&nbsp;</span>
                  </div>
                </a>
                <div v-else class="select-wrapper">
                  <select class="custom-select bg-dark border-0 " v-model="day">
                    <option v-for="(day, index) in daysOfWeek" :key="day.name" :value="index">{{day.name}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 ">
              <div class="pl-4"><strong>{{$t('From')}}</strong></div>
              <div class="col-8 pr-0 d-flex justify-content-between align-items-center">
                <div class="select-wrapper">
                  <select v-model="fromHours" class="custom-select bg-dark border-0 ">
                    <option v-for="i in hours" :key="i" :value="i">{{i}}</option>
                  </select>
                </div>
                <span class="px-2">:</span>
                <div class="select-wrapper">
                  <select v-model="fromMinutes" class="custom-select bg-dark border-0 ">
                    <option v-for="i in minutes" :key="i" :value="i">{{i}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 ">
              <div class="pl-4"><strong>{{$t('To')}}</strong></div>
              <div class="col-8 pr-0 d-flex justify-content-between align-items-center">
                <div class="select-wrapper">
                  <select v-model="toHours" class="custom-select bg-dark border-0 ">
                    <option v-for="i in hours" :key="i" :value="i">{{i}}</option>
                  </select>
                </div>
                <span class="px-2">:</span>
                <div class="select-wrapper">
                  <select v-model="toMinutes" class="custom-select bg-dark border-0 ">
                    <option v-for="i in minutes" :key="i" :value="i">{{i}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 ">
              <div class="pl-4"><strong>{{$t('Interval')}}</strong></div>
              <div class="col-8 pr-0 d-flex justify-content-between align-items-center">
                <div class="select-wrapper">
                  <select v-model="interval" class="custom-select bg-dark border-0 ">
                    <option v-for="i in intervals" :key="i" :value="i">{{i}} min</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 ">
              <div class="pl-4"><strong>{{$t('Jingles')}}</strong></div>
              <div class="col-8 pr-0 ">
                <a href="#" @click.prevent="displayStatus = 'jingleSelect'">
                  <div
                    class="bg-dark text-white px-3 py-2 d-block d-flex justify-content-start align-items-center rounded clickable">
                    {{selectedJingles.length > 0 ? selectedJingles.map(jingle => jingle.title).join(', ') : '--'}}
                  </div>
                </a>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 mt-2 jingle-datepicker">
              <div class="pl-4" style="align-self: flex-start"><strong>{{$t('Active from')}}</strong><br/>&nbsp;</div>
              <div class="col-8 pr-0" style="align-self: flex-end; max-width: fit-content; flex: 0 0 auto !important;">
                <Datepicker v-model="activeFrom" :inline="true" :monday-first="true"></Datepicker>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center p-1 mt-2 jingle-datepicker">
              <div class="pl-4" style="align-self: flex-start"><strong>{{$t('Active to')}}</strong><br/>&nbsp;</div>
              <div class="col-8 pr-0" style="align-self: flex-end; max-width: fit-content; flex: 0 0 auto !important;">
                <Datepicker v-model="activeTo" :inline="true" :monday-first="true"></Datepicker>
              </div>
            </div>
            <div v-if="displayStatus === 'main'" class="px-1 mb-1 mt-2">
              <div @click="save()" class="pointer bg-gray text-center clickable rounded px-4 py-3">
                <span :class="canSave ? 'text-primary' : 'text-muted'">{{$t('Save')}}</span>
              </div>
            </div>
            <div v-if="isEdit" class="px-1 mb-1 mt-2">
              <div @click="deleteSchedule()" class="pointer bg-gray text-center text-danger clickable rounded px-4 py-3">
                <span>{{$t('Delete')}}</span>
              </div>
            </div>
          </template>
          <template v-if="displayStatus === 'jingleSelect'">
            <ObjectMultiSelect
              :titleField="'title'"
              :preSelected="selectedJingles"
              :options="jingles"
              :onChange="jinglesChange"
              :onPickingDone="() => { displayStatus = 'main' }"
            ></ObjectMultiSelect>
          </template>
        </div>
      </transition>
      <OverlayLoader :displayOverlay="loadingJingles || savingSchedulesCount > 0 || loadingJingleBlock || deletingSchedule" />
    </div>
  </div>
</template>

<script>
import days from '@/utils/days'
import musicboxClient from '@/utils/musicboxClient'
import { secondsToMinAndSec } from '@/utils/numberUtils'
import { dateString } from '@/utils/dateUtils'
import { handle400 } from '@/utils/responseUtils'
import { ROUTE_JINGLE_SCHEDULE } from '@/const/routeNames'
import DesktopBackLink from '@/components/shared/DesktopBackLink.vue'

export default {

  name: 'JingleScheduleAddEdit',

  components: {
    DesktopBackLink
  },

  created () {
    this.isEdit = this.$route.params.id != null
    if (this.$store.state.jingleScheduleEdit.editedSchedule == null) { this.$store.commit('initEditedJingleSchedule') }
    this.loadingJingles = true
    musicboxClient
      .getJingles()
      .then(res => {
        res.data.forEach(jingle => {
          jingle.minutesAndSeconds = secondsToMinAndSec(jingle.duration)
          jingle.titleLc = jingle.title.toLowerCase()
        })
        this.jingles = res.data
        if (this.isEdit) {
          this.loadingJingleBlock = true
          musicboxClient
            .getJingleBlock(this.$store.state.audio.currentBox.uuid, this.$route.params.id)
            .then(res => {
              this.activeFrom = res.data.active_from ? new Date(res.data.active_from) : null
              this.activeTo = res.data.active_to ? new Date(res.data.active_to) : null
              this.interval = res.data.interval ? res.data.interval : null
              const startTime = res.data.start_time.split(':')
              const endTime = res.data.end_time.split(':')
              this.fromHours = startTime[0]
              this.fromMinutes = startTime[1]
              this.toHours = endTime[0]
              this.toMinutes = endTime[1]
              this.day = res.data.start_day
              const selectedJingles = []
              const jingleMap = {}
              this.jingles.forEach(jingle => {
                jingleMap[jingle.id] = jingle
              })
              res.data.jingles.forEach(selectedJingle => {
                if (jingleMap[selectedJingle.id]) {
                  selectedJingles.push(jingleMap[selectedJingle.id])
                }
              })
              this.selectedJingles = selectedJingles
            })
            .catch(e => {
              this.$notify.danger(this.$t('Failed to get jingle block'))
              console.log(e)
            })
            .then(() => { this.loadingJingleBlock = false })
        }
      })
      .catch(e => { this.$notify.danger(this.$t('Failed to get jingles')) })
      .then(() => { this.loadingJingles = false })
  },

  data () {
    const hours = []
    for (var i = 0; i < 24; i++) {
      hours.push((i < 10 ? '0' : '') + i + '')
    }
    const minutes = []
    for (var j = 0; j < 60; j += 1) {
      minutes.push((j < 10 ? '0' : '') + j + '')
    }
    return {
      displayStatus: 'main',
      daysOfWeek: days,
      hours,
      minutes,
      jingles: [],
      intervals: [15, 30, 45, 60, 90, 120, 180, 240],
      loadingJingleBlock: false,
      loadingSchedule: false,
      savingSchedule: false,
      isEdit: false,
      loadingJingles: false,
      deletingSchedule: false,
      savingSchedulesCount: 0,
      ROUTE_JINGLE_SCHEDULE
    }
  },

  computed: {
    canSave () {
      if (this.isEdit) {
        return this.selectedJingles != null && this.selectedJingles.length > 0
      }
      return this.selectedJingles != null && this.selectedJingles.length > 0 && this.selectedDaysOfWeek.size > 0
    },
    ...(function () {
      const map = {}
      const props = [
        'selectedDaysOfWeek',
        'fromHours',
        'fromMinutes',
        'toHours',
        'toMinutes',
        'interval',
        'activeFrom',
        'activeTo',
        'selectedJingles',
        'day'
      ]
      props.forEach(key => {
        map[key] = {
          get () { return this.$store.state.jingleScheduleEdit.editedSchedule[key] },
          set (value) { this.$store.commit('updateEditedJingleSchedule', { key, value }) }
        }
      })
      return map
    })()
  },

  methods: {
    daySelectChange (selectedDays) {
      this.selectedDaysOfWeek = selectedDays
    },
    save () {
      if (!this.canSave) { return }

      var activeFrom = null
      var activeTo = null

      if (this.activeFrom) {
        activeFrom = dateString(this.activeFrom)
      }

      if (this.activeTo) {
        activeTo = dateString(this.activeTo)
      }

      if (this.isEdit) {
        this.savingSchedulesCount = 1
        const data = {
          active_from: activeFrom,
          active_to: activeTo,
          start_day: this.day,
          end_day: this.day,
          jingle_ids: this.selectedJingles.map(jingle => jingle.id),
          start_time: this.fromHours + ':' + this.fromMinutes,
          end_time: this.toHours + ':' + this.toMinutes,
          interval: this.interval,
          box__uuid: this.$store.state.audio.currentBox.uuid
        }
        musicboxClient
          .updateJingleSchedule(this.$store.state.audio.currentBox.uuid, this.$route.params.id, data)
          .then(res => {
            this.$store.commit('clearEditedJingleSchedule')
            this.$notify.success(this.$t('Jingle block updated'))
            this.$router.push(ROUTE_JINGLE_SCHEDULE)
          })
          .catch(e => {
            if (e.response && e.response.status === 400) { handle400(e.response.data, this) }
            this.$notify.danger(this.$t('Failed updating jingle block'))
          })
          .then(() => { this.savingSchedulesCount = 0 })
      } else {
        const requests = []

        this.selectedDaysOfWeek.forEach(day => {
          requests.push({
            active_from: activeFrom,
            active_to: activeTo,
            start_day: day,
            end_day: day,
            jingle_ids: this.selectedJingles.map(jingle => jingle.id),
            start_time: this.fromHours + ':' + this.fromMinutes,
            end_time: this.toHours + ':' + this.toMinutes,
            interval: this.interval,
            box__uuid: this.$store.state.audio.currentBox.uuid
          })
        })

        this.savingSchedulesCount = requests.length
        var errors = 0

        requests.forEach(req => {
          musicboxClient
            .createJingleSchedule(this.$store.state.audio.currentBox.uuid, req)
            .then(res => {})
            .catch(e => {
              errors++
              if (e.response && e.response.status === 400) { handle400(e.response.data, this) }
            })
            .then(() => {
              this.savingSchedulesCount--
              if (this.savingSchedulesCount === 0) {
                if (errors === 0) {
                  this.$store.commit('clearEditedJingleSchedule')
                  this.$notify.success(this.$t('Jingle block created'))
                  this.$router.push(ROUTE_JINGLE_SCHEDULE)
                } else {
                  this.$notify.danger(this.$t('Failed creating jingle block'))
                }
              }
            })
        })
      }
    },
    jinglesChange (value) {
      this.selectedJingles = value
    },
    deleteSchedule () {
      this.deletingSchedule = true
      musicboxClient
        .deleteJingleSchedule(this.$store.state.audio.currentBox.uuid, this.$route.params.id)
        .then(res => {
          this.$notify.success(this.$t('Jingle block deleted'))
        })
        .catch(e => { this.$notify.danger(this.$t('Failed to delete jingle block')) })
        .then(() => {
          this.deletingSchedule = false
          this.$store.commit('clearEditedJingleSchedule')
          this.$router.push(ROUTE_JINGLE_SCHEDULE)
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/JingleScheduleAddEdit.vue